import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SmallOrderBudgetComponent } from './small-order-budget.component';


const routes: Routes = [
  {
    path:'',
    component: SmallOrderBudgetComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmallOrderBudgetRoutingModule { }
